module.exports = __webpack_public_path__ + "static/amazon-cacd227c5bef224132cefc36a6a3838d.svg";